import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { ContextActionType, useDumbActionsContext } from '@europrocurement/flexy-components';
import { ColumnDatatable } from '@europrocurement/flexy-datatable';
import { ChampComplMentaireJsonldChampcomplementaireReadHtmlFieldTypeEnum } from '@europrocurement/l2d-domain/openApi/ApiOffre';
import { addItem, FaOptionIcon } from '@europrocurement/l2d-icons';
import { useOffreService } from '@europrocurement/l2d-domain';
import RoutedListing from '../components/RoutedListing';

import { getStringColumn } from '../listings';
import { getHtmlFieldTypeLabel } from '../forms/htmlFields';
import { PossibleTypes } from '../../Societes';
import { additionalFieldCreatePath, additionalFieldFichePath } from './routes';

const Panel: React.FunctionComponent = function () {
    const navigate = useNavigate();
    const { additionalFieldModel: model } = useOffreService();

    const goToCreate = React.useCallback(() => navigate(additionalFieldCreatePath), [navigate]);
    const goToFiche = React.useCallback(
        (item: { id: string | number }) => navigate(additionalFieldFichePath(item.id)),
        [navigate],
    );

    const contextActions: ContextActionType[] = React.useMemo(
        () => [
            {
                name: 'Créer un nouveau champ complémentaire',
                icon: <FaOptionIcon icon={['fas', 'plus-circle']} />,
                action: goToCreate,
            },
        ],
        [goToCreate],
    );

    useDumbActionsContext(contextActions);

    const columns: ColumnDatatable[] = [
        getStringColumn('libelle', 'Libellé'),
        getStringColumn('description'),
        {
            label: 'Type de champ HTML',
            displayLabel: true,
            render: (item: {
                htmlFieldType: ChampComplMentaireJsonldChampcomplementaireReadHtmlFieldTypeEnum;
            }) => (
                <Typography
                    variant="l2dtableCell"
                    color="text.gris70"
                >
                    {getHtmlFieldTypeLabel(item.htmlFieldType)}
                </Typography>
            ),
            isDisplayed: true,
            sortable: false,
            field: 'htmlFieldType',
        },
    ];

    return (
        <RoutedListing
            listingTitle="Liste des champs complémentaires"
            createButton={{
                label: 'Créer un nouveau champ complémentaire',
                icon: addItem,
                onClick: goToCreate,
            }}
            listingColumns={columns}
            model={model}
            filtersControl={false}
            searchBarType={PossibleTypes.ComplementaryField}
            onRowClick={goToFiche}
        />
    );
};

export default Panel;
